import useStore from './_store';
import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';
import MediaContentV2 from '@/components/media-content-v2.vue';
import { formats } from '@/common/format';
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import { mapAsyncData } from '@/plugins/asyncData';
import { asyncData } from './asyncData';
import ViewMore from "@/components/view-more.vue"

export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-area-overview'
    },
    asyncData: mapAsyncData(asyncData),
    mixins: [colorMixin(), spaceMixin()],
    components: {
        MediaContent: MediaContentV2,
        ViewMore
    },
    data: function() {
        return {
            areaInfo: {
                introPageExtraBackground: '',
                introPageExtraBackgroundMobile: '',
                name: '',
                introPageExtraDescription: '',
                introPageExtraHighlights: [],
            },
            bgImgOpt: {
                src: '',
                mobileSrc: ''
            },
            tags: [],
            desc: '',
            showAnimationEffects: true
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            // page: store => store.page || {},
            currencySymbol: store => store.currency?.symbol,
        }),
        subTitle({ areaInfo }) {
            return (areaInfo.type === 'neighborhood' && areaInfo.city) ? [areaInfo.state || '', areaInfo.city || ''].filter(Boolean).join(',') : areaInfo.state
        },
        suitableImg() {
            if (this.isMobileSize && this.bgImgOpt.mobileSrc) {
                return this.bgImgOpt.mobileSrc || this.areaInfo.introPageExtraBackgroundMobile || this.areaInfo.introPageExtraBackground; 
            }
            return this.bgImgOpt.src || this.areaInfo.introPageExtraBackground;
        },
        suitableTags() {
            if (!this.tags.length) {
                return (this.areaInfo.introPageExtraHighlights || []).map(it => {
                    return {
                        label: it
                    }
                })
            } else {
                return this.tags
            }
        },
        suitableDesc() {
            return this.desc || this.areaInfo.introPageExtraDescription
        },
        ...mapState({
            geoGraphic: store => store.geoGraphic || {},
            marketReport: store => store.marketReport || {}
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        bannerImg() {
            return this.isMobileSize ? this.bgImgOpt?.mobileSrc : this.bgImgOpt?.src
        },
        overviewList({ geoGraphic, marketReport, $t }) {
            let totalListings = (+(marketReport.listingCount || 0)).toFixed(0),
                averageSalePrice = +marketReport.listingAvgPrice || 0,
                medianSalesPrice = +marketReport.listingMedianPrice || 0,
                population = ((geoGraphic.demographics || {}).population || {}).populationCurrent || ((geoGraphic.demographics || {}).population || {}).population2010 || 0;
            return [
                { 
                    type: 'average', 
                    icon: 'icon-a-AverageSalesPrice',
                    label: $t('md-area-overview.average'), 
                    value: formats.currency({
                        value: Number(averageSalePrice || 0).toFixed(0),
                        noSpace: true,
                        currencySymbol: this.currencySymbol
                    })
                },
                { 
                    type: 'median',
                    icon: 'icon-a-MedianSalesPrice',
                    label: $t('md-area-overview.median'),
                    value: formats.currency({
                        value: Number(medianSalesPrice || 0).toFixed(0),
                        noSpace: true,
                        currencySymbol: this.currencySymbol
                    }) 
                },
                { 
                    type: 'population',
                    icon: 'icon-Population2',
                    label: $t('md-area-overview.population'),
                    value: formats.number(population) 
                },
                { 
                    type: 'totalListing', 
                    icon: 'icon-a-TotalListings1', 
                    label: $t('md-area-overview.totalListing'), 
                    value: formats.number(totalListings)  
                },
            ]
        },
    },
    methods: {
        getBannerStyle({ offsetTop, type, autoHeight, BANNER_TYPE }) {
            if (type == BANNER_TYPE.fullScreen) {
                let minHeight = Math.max(
                    window.innerHeight - offsetTop,
                    800
                );
                return {
                    minHeight: Math.max(minHeight, autoHeight)
                }
            }
        }
    }
}